import { NgModule } from '@angular/core';
import { CallParkingTileModule } from '../../views/call-parking/call-parking-tile.module';
import { ClockTileModule } from '../../views/clock/clock-tile.module';
import { NdtWaitTimesGraphTileModule } from '../../views/ndt-wait-times-graph-tile/ndt-wait-times-graph-tile.module';
import { PhoneQueuesTileModule } from '../../views/phone-queues/phone-queues-tile.module';
import { QueueMembersTileModule } from '../../views/queue-members/queue-members-tile.module';
import { DynamicTileDirective } from './dynamic-tile.directive';
import { TileWrapperComponent } from './tile-wrapper.component';

@NgModule({
   declarations: [DynamicTileDirective, TileWrapperComponent],
   exports: [DynamicTileDirective, TileWrapperComponent],
   imports: [
      ClockTileModule,
      CallParkingTileModule,
      QueueMembersTileModule,
      NdtWaitTimesGraphTileModule,
      PhoneQueuesTileModule,
   ],
})
export class TileWrapperModule {}
